import React, { useEffect } from 'react';
import { FormControl, Button, Grid, Paper, Typography, OutlinedInput, Box, FormLabel, FormHelperText, Switch, FormControlLabel } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { postLabDepartmentRequest, putLabDepartmentRequest, resetPostLabDepartment, resetPutLabDepartment } from '../../../../../redux/modules/laboratory/labDepartment/slice';

const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    code: yup.string().required("Code is required").max(10, "Code must be at most 10 characters"),
    description: yup.string().nullable(),
    sortOrder: yup.number().nullable().transform((value, originalValue) => originalValue === '' ? null : value),
});

const Form = ({ itemData, toggleList }) => {
    const dispatch = useDispatch();
    let { loading, postRes, putRes } = useSelector(state => state.labDepartment);
    const { register, handleSubmit, control, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: itemData ? { ...itemData, isActive: itemData.isActive !== false } : { isActive: true }
    });

    useEffect(() => {
        if (postRes) {
            if (postRes?.success) { toggleList(); }
            toast(postRes?.message);
            dispatch(resetPostLabDepartment());
        }
        if (putRes) {
            if (putRes?.success) { toggleList(); }
            toast(putRes?.message);
            dispatch(resetPutLabDepartment());
        }
    }, [postRes, putRes, toggleList, dispatch]);

    const onSubmit = (data) => {
        if (itemData?._id) {
            dispatch(putLabDepartmentRequest(data));
        } else {
            dispatch(postLabDepartmentRequest(data));
        }
    };

    return (
        <Box component={"form"} onSubmit={handleSubmit(onSubmit)}>
            <Paper sx={{ padding: 2, mt: 3 }} className='cardStyle'>
                <Typography variant="h5" className='title'>Department Form</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <FormLabel>Department Name</FormLabel>
                            <OutlinedInput className="inputfield" {...register('name')} size='small' placeholder="e.g. Biochemistry" />
                            {errors?.name?.message && <FormHelperText error>{errors?.name?.message}</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <FormLabel>Code</FormLabel>
                            <OutlinedInput className="inputfield" {...register('code')} size='small' placeholder="e.g. BIOCHEM" />
                            {errors?.code?.message && <FormHelperText error>{errors?.code?.message}</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <FormLabel>Description</FormLabel>
                            <OutlinedInput className="inputfield" {...register('description')} size='small' placeholder="Department description" multiline rows={2} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <FormLabel>Sort Order</FormLabel>
                            <OutlinedInput className="inputfield" {...register('sortOrder')} size='small' type="number" placeholder="0" />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Controller
                            name="isActive"
                            control={control}
                            render={({ field }) => (
                                <FormControlLabel
                                    control={<Switch checked={field.value} onChange={field.onChange} />}
                                    label="Active"
                                    sx={{ mt: 3 }}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'stretch', sm: 'center' }, gap: 2, mt: 3, justifyContent: { xs: 'center', sm: 'right' } }}>
                <Button className="commonBtn" type='submit' variant='contained' disabled={loading}>{itemData?._id ? "Update" : "Save"}</Button>
                <Button variant='outlined' className='btn cancelBtn' onClick={() => { toggleList() }}>Cancel</Button>
            </Box>
        </Box>
    );
};

export default Form;
